import { render, staticRenderFns } from "./TestQuestionName.vue?vue&type=template&id=41cb3910&scoped=true"
import script from "./TestQuestionName.vue?vue&type=script&lang=js"
export * from "./TestQuestionName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cb3910",
  null
  
)

export default component.exports